import { RadioInputLabel } from './DonationAmountRadioGroup.styled';
import { StaticAmount, StaticAmountContainer } from './ImpactDonationAmount/ImpactDonationAmount.styled';
import * as Styled from './SkeletonLoader.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ImpactDonationAmountContainer = () => /*#__PURE__*/_jsx(Styled.ImpactDonationAmountContainerSkeleton, {
  shouldUseFocusStyling: false,
  shouldShowErrorState: false,
  doFadeIn: false,
  children: /*#__PURE__*/_jsx(StaticAmountContainer, {
    children: /*#__PURE__*/_jsx(StaticAmount, {
      children: /*#__PURE__*/_jsx("span", {
        children: "\xA0"
      })
    })
  })
});
export const DonationAmountRadioGroupFieldset = () => {
  const defaultAmounts = [{
    amount: 0,
    isDefault: false,
    isVisible: true,
    name: 'preset1'
  }, {
    amount: 0,
    isDefault: false,
    isVisible: true,
    name: 'preset2'
  }, {
    amount: 0,
    isDefault: false,
    isVisible: true,
    name: 'preset3'
  }, {
    amount: 0,
    isDefault: false,
    isVisible: true,
    name: 'preset4'
  }];
  return /*#__PURE__*/_jsxs(Styled.DonationAmountRadioGroupFieldsetSkeleton, {
    doFadeIn: false,
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        display: 'none'
      }
    }), defaultAmounts.map(preset => /*#__PURE__*/_jsx(Styled.DonationAmountRadioInputWrapperSkeleton, {
      children: /*#__PURE__*/_jsx(RadioInputLabel, {
        isSelected: false,
        children: /*#__PURE__*/_jsx("span", {
          children: "\xA0"
        })
      })
    }, preset.name))]
  });
};